// Helper function to extract value from nested object or direct value
export const extractValue = (obj, key = 'count', fallback = 0) => {
  if (obj === null || obj === undefined) return fallback
  if (typeof obj === 'object') {
    return obj[key] !== undefined ? obj[key] : fallback
  }
  return obj || fallback
}

// Helper function to extract change type from nested object
export const extractChangeType = (obj, fallback = 'positive') => {
  if (obj === null || obj === undefined) return fallback
  if (typeof obj === 'object') {
    return obj.changeType || fallback
  }
  return fallback
}

// Format time ago
export const formatTimeAgo = (timestamp) => {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  const now = new Date()
  const diffInSeconds = Math.floor((now - date) / 1000)

  if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`
  return `${Math.floor(diffInSeconds / 86400)} days ago`
}

// Get activity color class
export const getActivityColor = (type) => {
  switch (type) {
    case 'success':
    case 'scan':
      return 'bg-success'
    case 'info':
    case 'connection':
      return 'bg-info'
    case 'warning':
    case 'issue':
      return 'bg-warning'
    case 'error':
      return 'bg-danger'
    default:
      return 'bg-primary'
  }
}

// Transform activity item
export const transformActivityItem = (item, index) => {
  const typeMap = {
    success: { icon: 'mdi:check', color: 'success' },
    info: { icon: 'mdi:sync', color: 'info' },
    warning: { icon: 'mdi:alert', color: 'warning' },
    error: { icon: 'mdi:alert-circle', color: 'danger' },
    scan: { icon: 'mdi:check-circle', color: 'success' },
    connection: { icon: 'mdi:sync', color: 'info' },
    issue: { icon: 'mdi:alert', color: 'warning' },
  }

  const activityType = item.type || 'info'
  const typeConfig = typeMap[activityType] || typeMap.info

  // Determine if we should show a button based on activity type
  const shouldShowButton = activityType === 'scan' && item.metadata?.scanId

  return {
    id: item.id || item.metadata?.scanId || item.metadata?.connectionId || index,
    type: activityType,
    icon: item.icon || typeConfig.icon,
    action: item.title || item.action || 'Activity',
    description: item.description || item.message || '',
    button: shouldShowButton ? 'View Report' : item.button || item.actionButton,
    link: item.link || (shouldShowButton ? `/integrations` : item.url),
    timestamp: item.timestamp || item.createdAt,
    metadata: item.metadata,
  }
}
